import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-d7b483aa"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "head-top"
};
const _hoisted_2 = {
  class: "w"
};
const _hoisted_3 = {
  class: "head-logo"
};
const _hoisted_4 = {
  href: "/index.html"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "head-infor"
};
const _hoisted_7 = ["href", "target"];
const _hoisted_8 = ["href"];
const _hoisted_9 = ["href"];
const _hoisted_10 = {
  key: 3,
  href: "/trainList.html",
  class: "goMyTrain"
};
const _hoisted_11 = {
  key: 4,
  class: "head-login"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-xingzhuang login-img"
}, null, -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "登录", -1));

const _hoisted_14 = [_hoisted_12, _hoisted_13];
const _hoisted_15 = {
  key: 5,
  class: "head-user"
};
const _hoisted_16 = {
  class: "avatar-box"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  key: 1,
  class: "iconfont icon-xingzhuang user-img"
};
const _hoisted_19 = {
  class: "user-name"
};

const _hoisted_20 = /*#__PURE__*/_createTextVNode("账号设置");

const _hoisted_21 = /*#__PURE__*/_createTextVNode("退出");

const _hoisted_22 = {
  class: "head-nav"
};
const _hoisted_23 = ["href", "target"];
const _hoisted_24 = {
  class: "fixPostion"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  const _component_el_dropdown = _resolveComponent("el-dropdown");

  const _component_ArrowUp = _resolveComponent("ArrowUp");

  const _component_el_icon = _resolveComponent("el-icon");

  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", !$props.isNav ? 'header-set' : ''])
  }, [_createElementVNode("div", {
    class: "head clearfix",
    style: _normalizeStyle({
      backgroundImage: 'url(' + $data.headerBg + ')'
    })
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("a", _hoisted_4, [_createElementVNode("img", {
    src: $data.logoUrl,
    alt: ""
  }, null, 8, _hoisted_5)])]), _createElementVNode("div", _hoisted_6, [$data.headList.length && ($data.zhsRole == 1 || $data.userRole == 1) ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.headList, (item, index) => {
    return _openBlock(), _createElementBlock("a", {
      class: "guard-center",
      key: index,
      href: item.target_url ? item.target_url : '',
      target: item.target_type ? '_blank' : '_self'
    }, _toDisplayString(item.name), 9, _hoisted_7);
  }), 128)) : _createCommentVNode("", true), $data.onlineTeache && ($data.zhsRole || $data.userRole) ? (_openBlock(), _createElementBlock("a", {
    key: 1,
    class: "online",
    href: $data.onlineTeache ? $data.onlineTeache.target_url : '',
    target: "_blank"
  }, _toDisplayString($data.onlineTeache.name), 9, _hoisted_8)) : _createCommentVNode("", true), $data.userInfo && $data.userInfo.roleId ? (_openBlock(), _createElementBlock("a", {
    key: 2,
    class: "online",
    href: $data.backUrl,
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.goBackPlat && _ctx.goBackPlat(...args)),
    target: "_blank"
  }, " 管理后台 ", 8, _hoisted_9)) : _createCommentVNode("", true), $data.showMyTraining ? (_openBlock(), _createElementBlock("a", _hoisted_10, "我的培训项目")) : _createCommentVNode("", true), $data.showLogin && !$data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", {
    class: "login-btn",
    onClick: _cache[1] || (_cache[1] = $event => $options.handleLogin())
  }, _hoisted_14)])) : _createCommentVNode("", true), $data.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [$data.userInfo.avatar ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "avatar",
    src: $data.userInfo.avatar
  }, null, 8, _hoisted_17)) : (_openBlock(), _createElementBlock("i", _hoisted_18))]), _createVNode(_component_el_dropdown, {
    trigger: "hover",
    "append-to-body": false,
    "show-arrow": false
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
        onClick: $options.goAccountSet
      }, {
        default: _withCtx(() => [_hoisted_20]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_dropdown_item, {
        onClick: $options.handleLogout
      }, {
        default: _withCtx(() => [_hoisted_21]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_19, _toDisplayString($data.userInfo.realname), 1)]),
    _: 1
  })])) : _createCommentVNode("", true)])])]), _createElementVNode("div", {
    class: _normalizeClass(["head-btn", [!$props.isNav ? 'btn-none' : '']])
  }, [_createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.navList.slice(0, 10), ({
    nav_name,
    target_url,
    target_type
  }, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["nav-btn", $data.currentPage === nav_name ? 'nav-active' : ''])
    }, [_createElementVNode("a", {
      href: target_url,
      class: "noticenav",
      target: target_type ? '_blank' : '_self'
    }, _toDisplayString(nav_name), 9, _hoisted_23)], 2);
  }), 128))])], 2), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", {
    class: "back-top",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.backTop && $options.backTop(...args))
  }, [_createVNode(_component_el_icon, {
    size: 20
  }, {
    default: _withCtx(() => [_createVNode(_component_ArrowUp)]),
    _: 1
  })])])], 4)], 2);
}